/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_It_Works__Hero__SubtitleInputs */

const en_how_it_works__hero__subtitle = /** @type {(inputs: How_It_Works__Hero__SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Master the art of strategic bidding and win premium products at unbeatable prices`)
};

/**
* | output |
* | --- |
* | "Master the art of strategic bidding and win premium products at unbeatable prices" |
*
* @param {How_It_Works__Hero__SubtitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const how_it_works__hero__subtitle = /** @type {((inputs?: How_It_Works__Hero__SubtitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_It_Works__Hero__SubtitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_how_it_works__hero__subtitle(inputs)
});